const PRELOAD_TIMEOUT_MS = 5000;

function collectUrls(value, urls = new Set()) {
  if (Array.isArray(value)) {
    value.forEach((item) => collectUrls(item, urls));
    return urls;
  }
  if (!value || typeof value !== "object") return urls;
  Object.keys(value).forEach((key) => {
    const child = value[key];
    if (key === "url" && typeof child === "string" && isSafeImageUrl(child)) {
      urls.add(child);
    } else {
      collectUrls(child, urls);
    }
  });
  return urls;
}

function isSafeImageUrl(url) {
  if (url.startsWith("/")) return true;
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch (error) {
    return false;
  }
}

function preloadUrl(url) {
  return new Promise((resolve) => {
    const image = new Image();
    const timeout = window.setTimeout(
      () => resolve({ url, loaded: false }),
      PRELOAD_TIMEOUT_MS
    );
    image.onload = () => {
      window.clearTimeout(timeout);
      resolve({ url, loaded: true });
    };
    image.onerror = () => {
      window.clearTimeout(timeout);
      resolve({ url, loaded: false });
    };
    image.src = url;
  });
}

async function preload(config) {
  const urls = Array.from(collectUrls(config));
  const results = await Promise.all(urls.map(preloadUrl));
  return {
    total: results.length,
    loaded: results.filter((result) => result.loaded).length,
    failed: results.filter((result) => !result.loaded).map((result) => result.url),
  };
}

function preloadCritical(config = {}) {
  return preload({
    dashboard: config.dashboard,
  });
}

export default {
  collectUrls,
  preload,
  preloadCritical,
};
